import { render } from "./BlogDetailsTwo.vue?vue&type=template&id=8d53a96a"
import script from "./BlogDetailsTwo.vue?vue&type=script&lang=js"
export * from "./BlogDetailsTwo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__